import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { CardTitle } from '../ui/card';
import { Brain, Lock, BookOpen } from 'lucide-react';

const PERIODS = [
  { id: '1mo', label: '1M' },
  { id: '3mo', label: '3M' },
  { id: '6mo', label: '6M' },
  { id: '1y', label: '1Y' },
  { id: '2y', label: '2Y' },
];

const ChartControls = ({ symbol, isPro, period, onPeriodChange, onAddJournal }) => (
  <div className="flex flex-wrap items-center justify-between gap-3">
    <CardTitle className="flex items-center gap-2 text-lg">
      <Brain className="text-purple-600" size={20} />
      AI Charting — {symbol}
      {!isPro && (
        <Badge variant="outline" className="ml-2 text-xs">
          <Lock size={11} className="mr-1" /> Pro for AI commentary
        </Badge>
      )}
    </CardTitle>
    <div className="flex gap-1 items-center">
      {PERIODS.map((p) => (
        <Button
          key={p.id}
          size="sm"
          variant={period === p.id ? 'default' : 'outline'}
          className={period === p.id ? 'bg-purple-600 hover:bg-purple-700' : ''}
          onClick={() => onPeriodChange(p.id)}
          data-testid={`chart-period-${p.id}`}
        >
          {p.label}
        </Button>
      ))}
      <Button
        size="sm"
        variant="outline"
        className="ml-2 text-purple-600"
        onClick={onAddJournal}
        disabled={!isPro}
        title={isPro ? 'Add to Journal' : 'Pro required'}
        data-testid="chart-add-to-journal-btn"
      >
        <BookOpen size={14} className="mr-1" />
        Journal
      </Button>
    </div>
  </div>
);

export default ChartControls;
